<template>
    <div class="bg-info row" style="height: 70px">
        <q-scroll-area
            ref="scroll"
            horizontal
            :thumb-style="thumbStyle"
            :bar-style="barStyle"
            class="col-grow full-height scroll"
        >
            <q-tabs
                indicator-color="transparent"
                active-color="primary"
                active-bg-color="primary-2"
                class="full-height text-primary"
                :mobile-arrows="false"
                v-model="tab"
            >
                <q-tab
                    class="tab"
                    content-class="tab-content"
                    v-for="item in list"
                    :key="item.name"
                    :name="item.name"
                >
                    <div class="full-width">
                        <q-img
                            basic
                            contain
                            height="25px"
                            :src="item.logoUrl"
                        />
                    </div>
                    <div
                        style="
                            font-size: 12px;
                            text-transform: none;
                            white-space: normal;
                            padding: 0px 4px;
                            height: 35px;
                        "
                    >
                        {{ item.name || item.groupName }}
                    </div>
                </q-tab>
            </q-tabs>
        </q-scroll-area>
    </div>
</template>

<script>
import useCategoryList from "@/mixins/useCategoryList";
export default {
    name: "CategoryLevel1Bar",
    mixins: [useCategoryList],
    props: ["L1"],
    data() {
        return {
            thumbStyle: {
                borderRadius: "1.5px",
                backgroundColor: "#282669",
                height: "3px",
                opacity: 1,
            },
            barStyle: {
                right: "2px",
                borderRadius: "9px",
                backgroundColor: "#027be3",
                width: "9px",
                opacity: 0,
            },
            list: [],
            tab: "",
        };
    },
    created() {
        this.loadCategoryList().then((result) => {
            console.log(result);
            this.list = result;
            console.log(this.list, this.tab);
            this.moveToCategory(this.tab);
        });
    },
    watch: {
        L1: {
            immediate: true,
            handler: function (value) {
                if (value) {
                    console.log(this.list);
                    this.tab = value;
                    this.moveToCategory(this.tab);
                }
            },
        },
        tab: {
            handler: function (value) {
                console.log({ value });
                this.$store.commit("allProduct/setL1", value);
            },
        },
    },
    methods: {
        async moveToCategory(name) {
            await this.$nextTick();
            const index = this.list.findIndex((item) => item.name == name);
            this.scrollTo(index);
        },
        scrollTo(index) {
            if (this.$refs.scroll) {
                this.$refs.scroll.setScrollPosition(70 * (index - 1));
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.q-btn {
    height: 50px;
    width: 36px;
}
.q-btn--rectangle {
    border-radius: 0px;
}
.q-badge--floating {
    position: absolute;
    top: -6px;
    right: 5px;
    cursor: inherit;
}
.q-tab {
    padding: 0px;
    align-items: flex-end;
}
.scroll {
    overflow-y: hidden;
}
.tab {
    width: 70px!important;
}
.bg-primary-2 {
    background-color: #c0bfd5;
}
</style>

<style scoped>
.tab-img {
    height: 27px;
}
.tab-text {
    font-size: 12px !important;
}
>>> .q-tab__content {
    min-width: unset;
}
</style>
